import * as ActionTypes from '../constants/actions';

const default_state = {
	activeRoom : {},
};

export default function room(state = default_state, action) {
	switch (action.type) {
		case ActionTypes.ROOM.SET_ACTIVE_ROOM_DATA: {
			return {
				...state,
				activeRoom : action.activeRoom
			};
		}
		case ActionTypes.ROOM.UNSET_ACTIVE_ROOM_DATA: {
			return {
				...state,
				activeRoom : {}
			};
		}
		default: {
			return state;
		}
	}
}
